// extracted by mini-css-extract-plugin
module.exports = {"bordered_result":"algemeen-taxatie-data-grid_bordered_result__2FchM","platform_errors":"algemeen-taxatie-data-grid_platform_errors__1kfZy"};